import {
  FETCH_CUSTOMER_ARTICLES_FAIL,
  FETCH_CUSTOMER_ARTICLES_REQUEST,
  FETCH_CUSTOMER_ARTICLES_SUCCESS,
} from "../constants";

export const fetchCusArticlesReducer = (state = {}, action) => {
  switch (action.type) {
    case FETCH_CUSTOMER_ARTICLES_REQUEST:
      return { ...state, loading: true };
    case FETCH_CUSTOMER_ARTICLES_SUCCESS:
      return { articles: action.payload, loading: false };
    case FETCH_CUSTOMER_ARTICLES_FAIL:
      return { error: action.payload, success: false };
    default:
      return state;
  }
};
